<script setup lang="ts">
import type { TasksKanbanStage } from '@brighterly/lib-core-types/tasks-kanban/enums'

import { TASKS_KANBAN_STAGE_COLOR } from '../config/tasks-kanban-stage-color.const'

defineOptions({
  name: 'TasksKanbanStage',
})

defineProps<{
  stage: TasksKanbanStage
}>()
</script>

<template>
  <div
    :class="['tkb-stage', TASKS_KANBAN_STAGE_COLOR[stage]]"
  >
    <div
      v-if="$slots.head"
      class="tkb-stage__head"
    >
      <slot name="head" />
    </div>
    <div
      v-if="$slots.default"
      class="tkb-stage__body"
    >
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TasksKanbanStage.scss" />
